// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
   padding: 16px;
   border: 1px solid #0f0f0f;
   margin-top: 70px;
   width: 400px;
}

h3 {
   text-align: center;
   color: #5e5e5e;
   font-family: "Calibri Light", sans-serif;
}

h4 {
   color: #5e5e5e;
   font-family: "Calibri Light", sans-serif;
   font-weight: bold;
}

h1 {
   text-align: center;
   color: #337ab7;
   font-family: "Calibri Light", sans-serif;
   font-weight: bold;

}

.register-form {
   /*width: 50%;*/
   /*height: 50%;*/
   /*margin: 0 auto;*/
   padding: 16px;
}

input[type=text], input[type=password], input[type=tel], input[type=email] {
   width: 100%;
   padding: 12px 20px;
   margin: 5px 0;
   display: inline-block;
   border: 1px solid #ccc;
   box-sizing: border-box;
}

.default {
   background-color: #337ab7;
   color: white;
   margin: 8px 0;
}

.wrapper {
   text-align: center;
   /*text-align: left;*/
}

#logo {
   width: 20px;
   height: 20px;
   margin-top: -5px;
}

a {
   color: #8c8c8c
}

a:hover {
   color: #f4f5f7;
   text-decoration: blink;
}

@media screen and (max-width: 400px) {
   .container {
      display: block;
      float: none;
      margin-top: 70px;
      width: 360px;
   }

}

img {
   width: 80px;
   height: auto;
   margin: 5px;
}

::ng-deep .mat-button:hover .mat-button-focus-overlay {
   opacity: 0.04 !important;
}


input {
   height: 32px;
   padding-right: 36px;
   width: 100%;
}

.pwd-hint {
   margin-top: 5px;
   margin-bottom: 1em;
}

mat-icon {
   width: 32px;
   height: 32px;
   line-height: 32px;
   padding: 4px;
   text-align: center;
   position: absolute;
   right: 0;
   top: 0;
   bottom: auto;
   margin-top: 5px;
}

.error {
   font-size: 12px;
   color: #d32f2f;
}
`, "",{"version":3,"sources":["webpack://./src/app/admin/set-password/set-password.component.css"],"names":[],"mappings":"AAAA;GACG,aAAa;GACb,yBAAyB;GACzB,gBAAgB;GAChB,YAAY;AACf;;AAEA;GACG,kBAAkB;GAClB,cAAc;GACd,wCAAwC;AAC3C;;AAEA;GACG,cAAc;GACd,wCAAwC;GACxC,iBAAiB;AACpB;;AAEA;GACG,kBAAkB;GAClB,cAAc;GACd,wCAAwC;GACxC,iBAAiB;;AAEpB;;AAEA;GACG,cAAc;GACd,eAAe;GACf,kBAAkB;GAClB,aAAa;AAChB;;AAEA;GACG,WAAW;GACX,kBAAkB;GAClB,aAAa;GACb,qBAAqB;GACrB,sBAAsB;GACtB,sBAAsB;AACzB;;AAEA;GACG,yBAAyB;GACzB,YAAY;GACZ,aAAa;AAChB;;AAEA;GACG,kBAAkB;GAClB,oBAAoB;AACvB;;AAEA;GACG,WAAW;GACX,YAAY;GACZ,gBAAgB;AACnB;;AAEA;GACG;AACH;;AAEA;GACG,cAAc;GACd,sBAAsB;AACzB;;AAEA;GACG;MACG,cAAc;MACd,WAAW;MACX,gBAAgB;MAChB,YAAY;GACf;;AAEH;;AAEA;GACG,WAAW;GACX,YAAY;GACZ,WAAW;AACd;;AAEA;GACG,wBAAwB;AAC3B;;;AAGA;GACG,YAAY;GACZ,mBAAmB;GACnB,WAAW;AACd;;AAEA;GACG,eAAe;GACf,kBAAkB;AACrB;;AAEA;GACG,WAAW;GACX,YAAY;GACZ,iBAAiB;GACjB,YAAY;GACZ,kBAAkB;GAClB,kBAAkB;GAClB,QAAQ;GACR,MAAM;GACN,YAAY;GACZ,eAAe;AAClB;;AAEA;GACG,eAAe;GACf,cAAc;AACjB","sourcesContent":[".container {\n   padding: 16px;\n   border: 1px solid #0f0f0f;\n   margin-top: 70px;\n   width: 400px;\n}\n\nh3 {\n   text-align: center;\n   color: #5e5e5e;\n   font-family: \"Calibri Light\", sans-serif;\n}\n\nh4 {\n   color: #5e5e5e;\n   font-family: \"Calibri Light\", sans-serif;\n   font-weight: bold;\n}\n\nh1 {\n   text-align: center;\n   color: #337ab7;\n   font-family: \"Calibri Light\", sans-serif;\n   font-weight: bold;\n\n}\n\n.register-form {\n   /*width: 50%;*/\n   /*height: 50%;*/\n   /*margin: 0 auto;*/\n   padding: 16px;\n}\n\ninput[type=text], input[type=password], input[type=tel], input[type=email] {\n   width: 100%;\n   padding: 12px 20px;\n   margin: 5px 0;\n   display: inline-block;\n   border: 1px solid #ccc;\n   box-sizing: border-box;\n}\n\n.default {\n   background-color: #337ab7;\n   color: white;\n   margin: 8px 0;\n}\n\n.wrapper {\n   text-align: center;\n   /*text-align: left;*/\n}\n\n#logo {\n   width: 20px;\n   height: 20px;\n   margin-top: -5px;\n}\n\na {\n   color: #8c8c8c\n}\n\na:hover {\n   color: #f4f5f7;\n   text-decoration: blink;\n}\n\n@media screen and (max-width: 400px) {\n   .container {\n      display: block;\n      float: none;\n      margin-top: 70px;\n      width: 360px;\n   }\n\n}\n\nimg {\n   width: 80px;\n   height: auto;\n   margin: 5px;\n}\n\n::ng-deep .mat-button:hover .mat-button-focus-overlay {\n   opacity: 0.04 !important;\n}\n\n\ninput {\n   height: 32px;\n   padding-right: 36px;\n   width: 100%;\n}\n\n.pwd-hint {\n   margin-top: 5px;\n   margin-bottom: 1em;\n}\n\nmat-icon {\n   width: 32px;\n   height: 32px;\n   line-height: 32px;\n   padding: 4px;\n   text-align: center;\n   position: absolute;\n   right: 0;\n   top: 0;\n   bottom: auto;\n   margin-top: 5px;\n}\n\n.error {\n   font-size: 12px;\n   color: #d32f2f;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
